export default {"src":"/_next/static/media/Postpartum Recovery.1b823db1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};